<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">项目：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">收支类型：</div>
        <el-select class="filter__input" size="mini" v-model="filters.bill_type" filterable placeholder="请选择">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in billTypeList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item" v-if="opid <= 4 || opid === 16">
        <div class="filter__name">申请人：</div>
        <operSelect v-model="filters.opid" :lists.sync="operLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">收支账户：</div>
        <el-select class="filter__input" size="mini" v-model="filters.pay_mode" filterable placeholder="请选择">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in payModeList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
      <button class="blue-small-btn mr-10" @click="download">导出</button>
      <router-link class="blue-small-btn ml-auto" :to="{path: '/ledgerEdit', query: {lid: 0}}">新建</router-link>
      <div class="flex jcb mt-10">
        <div class="filter__item">
          <div class="filter__name">收支ID：</div>
          <el-input v-model="filters.lids" placeholder="多个ID,逗号分割" size="mini" class="filter__input"></el-input>
        </div>
        <div class="filter__item">
          <div class="filter__name">金额：</div>
          <el-input v-model="filters.amount" placeholder="" size="mini" class="filter__input"></el-input>
        </div>
        <div class="filter__item">
          <div class="filter__name">备注：</div>
          <el-input v-model="filters.remark" placeholder="" size="mini" class="filter__input"></el-input>
        </div>
        <div class="filter__item">
          <div class="filter__name">口令墙：</div>
          <el-select class="filter__input" size="mini" v-model="filters.awid" filterable>
            <el-option :label="item.title" :value="item.awid" v-for="(item, index) in watchwordLists" :key="index"></el-option>
          </el-select>
        </div>
        <div class="filter__item">
          <div class="filter__name">任务墙：</div>
          <el-select class="filter__input" size="mini" v-model="filters.etid" filterable>
            <el-option :label="item.title" :value="item.etid" v-for="(item, index) in taskLists" :key="index"></el-option>
          </el-select>
        </div>
        <div class="filter__item" v-if="opid === 3 || opid === 16">
          <div class="filter__name">时间：</div>
          <el-date-picker
              v-model="filters.dateTime"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions" size='small'>
            </el-date-picker>
        </div>
      </div>
    </div>
    <div class="filter mt-10 mb-20">
      <div class="flex jcb">
        <button class="blue-small-btn mr-20" @click="editMultiReceive(2)">结算单上报</button>
        <button class="blue-small-btn mr-20" @click="editMultiReceive(3)">口令收款上报</button>
        <button class="blue-small-btn mr-20" @click="editMultiReceive(6)">任务墙上报</button>
        <button class="blue-small-btn" @click="uploadExpressDialog = !uploadExpressDialog">快递费导入</button>
      </div>
      <div class="ml-auto">
        <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in statusList" :key="index" @click="changeStatus(index)">{{item.name}}</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700" :summary-method="getSummaries" show-summary>
      <el-table-column prop="lid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="oper_nickname" label="申请人" width="100" align="center">
      </el-table-column>
      <el-table-column prop="title" label="项目" width="" align="center">
      </el-table-column>
      <el-table-column prop="awid" label="口令" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.awid">{{scope.row.aw_title}}({{scope.row.awid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="etid" label="任务" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.etid">{{scope.row.et_title}}({{scope.row.etid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="month" label="月份" width="" align="center">
      </el-table-column>
      <el-table-column prop="account" label="请款账号" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.account.startsWith('http')">
            <el-image style="width: 40px; height: 50px"
              :src="scope.row.account"
              :preview-src-list="[scope.row.account]">
            </el-image>
          </div>
          <div v-else>{{scope.row.account}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="verify" label="请款依据" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.bill_type === 0">
            <div v-if="scope.row.verify.startsWith('http')">
              <el-image style="width: 40px; height: 50px"
                :src="scope.row.verify"
                :preview-src-list="[scope.row.verify]">
              </el-image>
            </div>
            <div v-else>{{scope.row.verify}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="bill_type" label="收支类型" width="120" align="center">
        <template slot-scope="scope">
          <el-select v-model="scope.row.bill_type" size="small" @change="changeBillType(scope.$index)">
            <el-option v-for="item in billTypeList.slice(1)" :key="item.value" :label="item.name" :value="item.value"> </el-option>
          </el-select>
        </template>
        <!--
        <template slot-scope="scope">
          <div v-if="scope.row.bill_type == 7">快递费</div>
          <div v-if="scope.row.bill_type == 6">任务回款</div>
          <div v-if="scope.row.bill_type == 5">其他</div>
          <div v-if="scope.row.bill_type == 4">充值兑换</div>
          <div v-if="scope.row.bill_type == 3">口令回款</div>
          <div v-if="scope.row.bill_type == 2">上家回款</div>
          <div v-if="scope.row.bill_type == 1">收款</div>
          <div v-if="scope.row.bill_type == 0">请款</div>
        </template>
        -->
      </el-table-column>
      <el-table-column prop="amount" label="金额/实收" width="" align="center">
        <template slot-scope="scope">
          <div v-if="[2, 3, 6].includes(scope.row.bill_type) && scope.row.amount != scope.row.receive">
            <div>{{scope.row.amount}}</div>
            <div class="fc-red" @dblclick="editBind(scope.$index)">/{{scope.row.receive}}</div>
          </div>
          <div v-else>{{scope.row.amount}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="收款明细" width="" align="center">
        <template slot-scope="scope">
          <div v-if="[1, 2, 3, 6].includes(scope.row.bill_type)">
            <el-tooltip placement="top" effect="light" v-if="scope.row.lrid">
              <div slot="content">
                <div>交易类型：{{scope.row.bill_info.methods}}</div><br />
                <div>交易渠道：{{scope.row.bill_info.channel}}</div><br />
                <div>账号：{{scope.row.bill_info.account}}</div><br />
                <div>昵称：{{scope.row.bill_info.username}}</div><br />
                <div>交易时间：{{formatTimeStamp(scope.row.bill_info.trade_time)}}</div><br />
                <div>备注：{{scope.row.bill_info.remark}}</div><br />
              </div>
              <el-button size="mini" v-if="scope.row.confirm">显示</el-button>
              <el-button type="text" @click="editBind(scope.$index)" v-if="scope.row.confirm === 0">绑定</el-button>
            </el-tooltip>
            <el-button type="text" @click="editBind(scope.$index)" v-if="scope.row.lrid === 0">绑定</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="bill_img" label="截图" width="" align="center">
        <template slot-scope="scope">
          <div v-if="[0, 4, 5, 7].includes(scope.row.bill_type) && filters.status === 0">
            <button class="blue-small-btn" @click="editCost(scope.$index)">通过</button>
          </div>
          <div v-else >
            <div v-if="scope.row.bill_img">
              <div @click="previewURL(scope.row.lid)">
                <img :src="scope.row.bill_img" style="width:40px;height:50px;" alt="" />
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pay_time" label="打款时间" width="" align="center">
      </el-table-column>
      <el-table-column prop="pay_mode" label="收支账号" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.pay_mode == 10">天河蚂蚁</div>
          <div v-if="scope.row.pay_mode == 9">廖清</div>
          <div v-if="scope.row.pay_mode == 8">沙市蚂蚁</div>
          <div v-if="scope.row.pay_mode == 7">虚拟账号</div>
          <div v-if="scope.row.pay_mode == 6">诗雄招商银行卡</div>
          <div v-if="scope.row.pay_mode == 5">云山招商银行卡</div>
          <div v-if="scope.row.pay_mode == 4">极推公户</div>
          <div v-if="scope.row.pay_mode == 3">小小贝微信</div>
          <div v-if="scope.row.pay_mode == 2">诗雄支付宝</div>
          <div v-if="scope.row.pay_mode == 1">云山支付宝</div>
          <div v-if="scope.row.pay_mode == 0">未打款</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="打款审核" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 2">取消</div>
          <div v-if="scope.row.status == 1">已完成</div>
          <div v-if="scope.row.status == 0">未打款</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="备注" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.remark">
            <div v-if="scope.row.bill_type == 4">
              <div v-html="scope.row.remark"></div>
            </div>
            <div v-else>
              <span class="underline fc-blue pointer">{{scope.row.remark}}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc" v-if="filters.status === -1">
            <router-link class="blue-small-btn ml-10" :to="{path: '/ledgerEdit', query: {lid: scope.row.lid}}">编辑</router-link>
          </div>
          <div class="flex jcc" v-if="filters.status === 0">
            <button class="blue-small-btn ml-10" @click="cancelLedger(scope.row.lid)">取消</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="打款信息" :visible.sync="costDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item mt-20">
              <div class="dataForm__name">项目</div>
              <el-select placeholder="请选择" v-model="costInfo.adid" :disabled="true">
                <el-option :label="item.title" :value="item.adid" v-for="(item, index) in adLists" :key="index"></el-option>
              </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">项目名称:</div>
            <div>{{costInfo.title}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">收款账号:</div>
            <div v-if="costInfo.account.startsWith('http') === false">{{costInfo.account}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">打款金额:</div>
            <div>{{costInfo.amount}}</div>
          </div>
          <div class="dataForm__item mt-20">
              <div class="dataForm__name">打款账户</div>
              <el-select placeholder="请选择" v-model="costInfo.pay_mode">
                <el-option v-for="item in payModeList" :key="item.value" :label="item.name" class="dataForm__input"  :value="item.value"> </el-option>
              </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">打款截图:</div>
            <uploadHeadImage :url.sync="costInfo.bill_img" :filename="filename" :itype="5"></uploadHeadImage>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">打款时间:</div>
            <el-date-picker v-model="costInfo.pay_time" type="datetime" placeholder="选择日期时间"> </el-date-picker>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">状态</div>
            <el-radio-group v-model="costInfo.status">
              <div class="dib mr-20">
                <el-radio :label="0">未打款</el-radio>
                <el-radio :label="1">已完成</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
        <div class="dataForm ml-40">
          <div class="" v-if="costInfo.account.startsWith('http')">
            <img :src="costInfo.account" height="400px" width="224px">
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="ledgerEdit">保存</div>
          <div class="gray-large-btn" @click="costDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="绑定账单金额" :visible.sync="bindDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">项目</div>
            <el-select placeholder="请选择" v-model="bindInfo.adid" :disabled="true">
              <el-option :label="item.title" :value="item.adid" v-for="(item, index) in adLists" :key="index"></el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">项目名称:</div>
            <div>{{bindInfo.title}}({{bindInfo.adid}})</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">口令墙:</div>
            <div>{{bindInfo.aw_title}}({{bindInfo.awid}})</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">状态</div>
            <el-radio-group v-model="bindInfo.confirm">
              <div class="dib mr-20">
                <el-radio :label="0">不确定</el-radio>
                <el-radio :label="1">确定</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">金额:</div>
            <div>{{bindInfo.amount}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">收款金额:</div>
            <el-input v-model="bindInfo.receive" placeholder="结算单总金额" size="mini" class="dataForm__input"></el-input>
            <button class="blue-small-btn ml-10" @click="getLedgerRecordLists(bindInfo.receive)">搜索</button>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">账单记录</div>
            <!--
            <el-select placeholder="请选择" v-model="bindInfo.lrid">
              <el-option v-for="item in ledgerRecordLists" :key="item.lrid" :label="item.title" class="dataForm__input"  :value="item.lrid"> </el-option>
            </el-select>
            -->
            <el-radio-group v-model="bindInfo.lrid">
              <el-radio v-for="item in ledgerRecordLists" :key="item.lrid" :label="item.lrid" class="db">
                {{item.title}}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="bindLedger">保存</div>
          <div class="gray-large-btn" @click="bindDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="收款批量上传上传" :visible.sync="multiReceiveDialog" size="tiny" width="1000px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">申请人</div>
            <el-select class="filter__input" size="mini" v-model="multiReceiveInfo.opid">
              <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists" :key="index"></el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">回款账户</div>
            <el-select placeholder="请选择" v-model="multiReceiveInfo.pay_mode">
              <el-option v-for="item in payModeList" :key="item.value" :label="item.name" class="dataForm__input"  :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">收款金额:</div>
            <el-input v-model="multiReceiveInfo.amount" placeholder="结算单总金额" size="mini" class="dataForm__input"></el-input>
            <button class="blue-small-btn ml-10" @click="getLedgerRecordLists(multiReceiveInfo.amount)">搜索</button>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">账单记录</div>
            <el-select placeholder="请选择" v-model="multiReceiveInfo.lrid">
              <el-option v-for="item in ledgerRecordLists" :key="item.lrid" :label="item.title" class="dataForm__input"  :value="item.lrid"> </el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name ml40">回款截图</div>
            <div class="headimg-container relative" style="width:250px">
              <uploadHeadImage :url.sync="multiReceiveInfo.bill_img" :itype="5"></uploadHeadImage>
            </div>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">备注</div>
            <el-input type="textarea" v-model="multiReceiveInfo.remark" rows=2 placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20" v-if="multiReceiveInfo.bill_type === 3">
            <div class="dataForm__name">下家</div>
            <el-select placeholder="请选择" v-model="multiReceiveInfo.acid" filterable  @change="chooseReceiveAdChn">
              <el-option :label="item.name" :value="item.acid" v-for="(item, index) in adChnLists" :key="index"></el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name" v-if="multiReceiveInfo.bill_type === 2">结算单：</div>
            <div class="dataForm__name" v-if="multiReceiveInfo.bill_type === 3">口令单：</div>
            <div class="dataForm__name" v-if="multiReceiveInfo.bill_type === 6">任务单：</div>
            <div class="bill-lists">
              <el-table ref="dataTable" :data="multiReceiveInfo.receiveLists" highlight-current-row style="width: 100%;" size="mini" class="">
                <el-table-column prop="min_price" label="广告" width="" align="center" v-if="multiReceiveInfo.bill_type === 2">
                  <template slot-scope="scope">
                    <el-select placeholder="请选择广告" v-model="scope.row.adid" size="mini" filterable>
                      <el-option :label="item.title" :value="item.adid" v-for="(item, index) in adLists.slice()" :key="index"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="min_price" label="口令" width="" align="center" v-if="multiReceiveInfo.bill_type === 3">
                  <template slot-scope="scope">
                    <el-select placeholder="请选择口令" v-model="scope.row.awid" size="mini" filterable @change="changeReceiveItem(scope.$index)">
                      <el-option :label="item.title" :value="item.awid" v-for="(item, index) in billWatchLists" :key="index"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="min_price" label="任务" width="" align="center" v-if="multiReceiveInfo.bill_type === 6">
                  <template slot-scope="scope">
                    <el-select placeholder="请选择任务" v-model="scope.row.etid" size="mini" filterable @change="changeReceiveItem(scope.$index)">
                      <el-option :label="item.title" :value="item.etid" v-for="(item, index) in billTaskLists" :key="index"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="month" label="月份" width="" align="center">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.month" size="mini" placeholder="请选择月份" filterable>
                      <el-option v-for="item in monthLists" :key="item.name" :label="item.month" :value="item.name"> </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="all_income" label="应收款" width="" align="center" v-if="[3, 6].includes(multiReceiveInfo.bill_type)">
                </el-table-column>
                <el-table-column prop="chn_amount" label="已收" width="" align="center" v-if="[3, 6].includes(multiReceiveInfo.bill_type)">
                </el-table-column>
                <el-table-column prop="amount" label="结算金额" width="" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.amount" size="mini" @input="(v)=>(scope.row.amount=v.replace(/[^\d.]/g,''))"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="删除" width="80" align="center">
                  <template slot-scope="scope">
                    <el-button type="danger" class="ml-40" size="mini" icon="el-icon-delete" circle @click="delReceiveItem(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="dataForm__item">
                <el-button size="mini" @click="addReceiveItem">添加结算数据</el-button>
              </div>
            </div>
          </div>
          <!--
          <div class="dataForm__item mt-20"> 格式:广告ID,月份（2024-01）,金额（第一行标题，第二行数据开始）</div>
          <el-upload
            class="upload-demo"
            drag
            action=""
            :limit="1"
            accept=".xls,.xlsx"
            :http-request="ledgerMultiReceiveUpdate"
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传.xls和.xlsx文件</div>
          </el-upload>
          -->
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="ledgerMultiReceiveCreate">保存</div>
          <div class="gray-large-btn" @click="multiReceiveDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="上传快递费记录" :visible.sync="uploadExpressDialog" size="tiny" width="600px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">打款账户</div>
            <el-select placeholder="请选择" v-model="expressInfo.pay_mode">
              <el-option v-for="item in payModeList" :key="item.value" :label="item.name" class="dataForm__input"  :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20"> 格式:月份（2024-01）,任务ID,标题，快递费（第一行标题，第二行数据开始）</div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">导入数据：</div>
            <el-upload
              ref="ledgerUpload"
              class="upload-demo"
              drag
              action=""
              :limit="1"
              accept=".xls,.xlsx"
              :http-request="ledgerExpressUpload"
              >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传.xls和.xlsx文件</div>
            </el-upload>
          </div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>
<script>
import {ledgerLists, ledgerEdit, ledgerMultiReceiveUpdate, ledgerMultiReceiveCreate, downloadLedgerLists, adWatchwordLists, ledgerRecordLists, adChnLists, taskLists, ledgerExpressUpload} from '../../../api/api'
import util from '../../../script/util'
import uploadHeadImage from '../../../components/uploadImage.vue'
import adSelect from '../../../components/data-select/adSelect.vue'
import operSelect from '../../../components/data-select/operSelect.vue'
import watchSelect from '../../../components/data-select/watchSelect.vue'
import taskSelect from '../../../components/data-select/taskSelect.vue'
export default {
  name: 'ledgerList',
  components: {
    uploadHeadImage,
    adSelect,
    operSelect,
    watchSelect,
    taskSelect
  },
  data () {
    return {
      opid: '',
      filters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        title: '',
        awid: '',
        etid: '',
        opid: '',
        bill_type: '',
        lids: '',
        amount: '',
        status: -1,
        pay_mode: '',
        remark: '',
        dateTime: '',
        start_time: '',
        end_time: ''
      },
      adLists: [],
      operLists: [],
      adChnLists: [],
      watchwordLists: [],
      billWatchLists: [],
      taskLists: [],
      billTaskLists: [],
      monthLists: [],
      ledgerRecordLists: [],
      lists: [],
      listLoading: false,
      costDialog: false,
      bindDialog: false,
      uploadExpressDialog: false,
      multiReceiveDialog: false,
      costInfo: {
        lid: '',
        adid: '',
        title: '',
        account: '',
        amount: '',
        bill_img: '',
        pay_mode: 0,
        pay_time: '',
        status: 0
      },
      multiReceiveInfo: {
        bill_type: '',
        opid: '',
        acid: '',
        pay_mode: '',
        amount: '',
        lrid: '',
        bill_img: '',
        remark: '',
        receiveLists: []
      },
      bindInfo: {
        lid: '',
        adid: '',
        title: '',
        awid: '',
        aw_title: '',
        account: '',
        amount: '',
        receive: '',
        confirm: '',
        lrid: ''
      },
      expressInfo: {
        pay_mode: ''
      },
      billTypeList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '请款',
          value: 0
        },
        {
          name: '收款',
          value: 1
        },
        {
          name: '上家回款',
          value: 2
        },
        {
          name: '口令回款',
          value: 3
        },
        {
          name: '充值兑换',
          value: 4
        },
        {
          name: '其他',
          value: 5
        },
        {
          name: '任务回款',
          value: 6
        },
        {
          name: '快递费',
          value: 7
        }
      ],
      payModeList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '未打款',
          value: 0
        },
        {
          name: '云山支付宝',
          value: 1
        },
        {
          name: '诗雄支付宝',
          value: 2
        },
        {
          name: '小小贝微信',
          value: 3
        },
        {
          name: '极推公户',
          value: 4
        },
        {
          name: '云山招商银行卡',
          value: 5
        },
        {
          name: '诗雄招商银行卡',
          value: 6
        },
        {
          name: '虚拟账号',
          value: 7
        },
        {
          name: '沙市蚂蚁',
          value: 8
        },
        {
          name: '廖清',
          value: 9
        },
        {
          name: '天河蚂蚁',
          value: 10
        }
      ],
      statusList: [
        {
          name: '所有',
          value: -1,
          status: 1
        },
        {
          name: '未打款',
          value: 0,
          status: 0
        },
        {
          name: '已完成',
          value: 1,
          status: 0
        },
        {
          name: '取消',
          value: 2,
          status: 0
        }
      ],
      pickerOptions: {
        shortcuts: []
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    previewURL (lid) {
      let images = []
      let initialViewIndex = 0
      this.lists.forEach((item) => {
        if (item.bill_img !== '') {
          images.push(item.bill_img)
        }
        if (item.lid === lid) {
          initialViewIndex = images.length - 1
        }
      })

      this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: initialViewIndex
        },
        images: images
      })
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['cost', 'income'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    dateTimeChange () {
      this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
      this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
    },
    getMonthList () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1

      for (let i = 0; i < 24; i++) {
        let monthStr = (month > 9) ? month.toString() : ('0' + month)
        let yearMonth = year.toString() + '-' + monthStr
        this.monthLists.push({'name': yearMonth, 'month': yearMonth})
        if (month === 1) {
          year = year - 1
          month = 12
        } else {
          month = month - 1
        }
      }
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value
      this.filters.p = 1
      this.getList()
    },
    editCost (index) {
      this.costDialog = true
      for (let key in this.costInfo) {
        this.costInfo[key] = this.lists[index][key]
      }
      this.costInfo.status = 1
      this.costInfo.pay_time = new Date()
    },
    editBind (index) {
      if (this.lists[index].confirm === 1) {
        return
      }

      this.bindDialog = true
      for (let key in this.bindInfo) {
        this.bindInfo[key] = this.lists[index][key]
      }

      if (this.bindInfo.lrid === 0) {
        this.bindInfo.lrid = ''
      }
      this.bindInfo.confirm = 1

      this.getLedgerRecordLists(this.bindInfo.receive)
    },
    editMultiReceive (billType) {
      this.multiReceiveDialog = true
      for (let key in this.multiReceiveInfo) {
        this.multiReceiveInfo[key] = ''
      }
      this.multiReceiveInfo.receiveLists = []
      this.multiReceiveInfo.bill_type = billType
      this.multiReceiveInfo.opid = this.opid
    },
    addReceiveItem () {
      this.multiReceiveInfo.receiveLists.push({
        month: '',
        awid: '',
        etid: '',
        adid: '',
        all_income: '',
        chn_amount: '',
        title: '',
        amount: ''
      })
    },
    delReceiveItem (index) {
      this.multiReceiveInfo.receiveLists.splice(index, 1)
    },
    changeReceiveItem (index) {
      if (this.multiReceiveInfo.bill_type === 3) {
        let awid = this.multiReceiveInfo.receiveLists[index].awid
        for (let key in this.billWatchLists) {
          if (this.billWatchLists[key].awid === awid) {
            this.multiReceiveInfo.receiveLists[index].all_income = this.billWatchLists[key].all_income
            this.multiReceiveInfo.receiveLists[index].chn_amount = this.billWatchLists[key].chn_amount
            break
          }
        }
      }

      if (this.multiReceiveInfo.bill_type === 6) {
        let etid = this.multiReceiveInfo.receiveLists[index].etid
        for (let key in this.billTaskLists) {
          if (this.billTaskLists[key].etid === etid) {
            this.multiReceiveInfo.receiveLists[index].all_income = this.billTaskLists[key].all_income
            this.multiReceiveInfo.receiveLists[index].chn_amount = this.billTaskLists[key].chn_amount
            break
          }
        }
      }
    },
    ledgerDetailEdit (params) {
      ledgerEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.bindDialog = false
          this.costDialog = false
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    chooseReceiveAdChn () {
      this.billWatchLists = []
      for (let key in this.watchwordLists) {
        let item = this.watchwordLists[key]
        if (this.multiReceiveInfo.acid === item.acid) {
          this.billWatchLists.push({
            title: item.title,
            awid: item.awid,
            acid: item.acid,
            all_income: item.all_income,
            chn_amount: item.chn_amount
          })
        }
      }
    },
    cancelLedger (lid) {
      let params = {
        lid: lid,
        status: 2
      }

      this.ledgerDetailEdit(params)
    },
    changeBillType (index, oper) {
      let lid = this.lists[index].lid
      let billType = this.lists[index].bill_type

      let params = {
        lid: lid,
        bill_type: billType
      }

      this.ledgerDetailEdit(params)
    },
    bindLedger () {
      let params = {
        lid: this.bindInfo.lid,
        lrid: this.bindInfo.lrid,
        confirm: this.bindInfo.confirm
      }

      let content = ''

      if (params['confirm'] === 0) {
        content = '不确定不可以绑定'
      }

      if (params['lrid'] === '') {
        content = '请选择绑定账单金额'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      this.ledgerDetailEdit(params)
    },
    ledgerMultiReceiveUpdate (params) {
      // 使用FormData传参数和文件
      let form = new FormData()

      let content = ''

      if (this.multiReceiveInfo['opid'] === '') {
        content = '请选择申请人'
      }

      if (this.multiReceiveInfo['pay_mode'] === '') {
        content = '请回款账号'
      }

      if (this.multiReceiveInfo['amount'] === '') {
        content = '请填写金额'
      }

      if (this.multiReceiveInfo['bill_img'] === '') {
        content = '请上传图片'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      form.append('opid', this.multiReceiveInfo['opid'])
      form.append('pay_mode', this.multiReceiveInfo['pay_mode'])
      form.append('amount', this.multiReceiveInfo['amount'])
      form.append('bill_img', this.multiReceiveInfo['bill_img'])
      form.append('remark', this.multiReceiveInfo['remark'])

      let file = params.file

      // 添加键值对
      form.append('file', file)

      ledgerMultiReceiveUpdate(form).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.multiReceiveDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    ledgerMultiReceiveCreate () {
      let params = {
        bill_type: this.multiReceiveInfo.bill_type,
        opid: this.multiReceiveInfo.opid,
        pay_mode: this.multiReceiveInfo.pay_mode,
        amount: this.multiReceiveInfo.amount,
        bill_img: this.multiReceiveInfo.bill_img,
        remark: this.multiReceiveInfo.remark
      }

      if (this.multiReceiveInfo['lrid'] !== '') {
        params['lrid'] = this.multiReceiveInfo['lrid']
      }

      let content = ''

      if (this.multiReceiveInfo['opid'] === '') {
        content = '请选择申请人'
      }

      if (this.multiReceiveInfo['pay_mode'] === '') {
        content = '请回款账号'
      }

      if (this.multiReceiveInfo['amount'] === '') {
        content = '请填写金额'
      }

      if (this.multiReceiveInfo['bill_img'] === '') {
        content = '请上传图片'
      }

      if (this.multiReceiveInfo['receiveLists'].length === 0) {
        content = '请填写数据'
      } else {
        for (let index = 0; index < this.multiReceiveInfo['receiveLists'].length; index++) {
          let row = this.multiReceiveInfo['receiveLists'][index]
          if ((row['adid'] === '' && row['awid'] === '' && row['etid'] === '') || row['month'] === '' || row['amount'] === '') {
            content = '请填写数据'
            break
          }
        }
      }

      // 验证金额
      let diffAmount = parseFloat(this.multiReceiveInfo.amount)
      for (let index = 0; index < this.multiReceiveInfo['receiveLists'].length; index++) {
        diffAmount = diffAmount - parseFloat(this.multiReceiveInfo['receiveLists'][index].amount)
      }

      if (util.isNotZero(diffAmount)) {
        content = '各金额相加不等于总金额'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      // 规格和特征
      params['receive'] = JSON.stringify({'lists': this.multiReceiveInfo.receiveLists})

      ledgerMultiReceiveCreate(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.multiReceiveDialog = false

          this.billWatchLists = this.watchwordLists.slice()
          this.billWathLists.splice(0, 1)
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    ledgerExpressUpload (params) {
      if (this.expressInfo.pay_mode === '') {
        this.$notify({
          title: '失败',
          message: '请选择账号',
          type: 'error'
        })
        return
      }

      let file = params.file

      // 使用FormData传参数和文件
      let form = new FormData()

      // 添加键值对
      form.append('file', file)

      form.append('pay_mode', this.expressInfo.pay_mode)

      ledgerExpressUpload(form).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.expressInfo.pay_mode = ''
          this.uploadExpressDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    ledgerEdit () {
      let params = {
        lid: this.costInfo.lid,
        bill_img: this.costInfo.bill_img,
        pay_mode: this.costInfo.pay_mode,
        status: this.costInfo.status
      }

      let content = ''

      if (params['pay_time'] === '') {
        content = '请选择打款时间'
      }

      if (params['bill_img'] === '') {
        content = '请上传图片'
      }

      if (params['pay_mode'] === 0) {
        content = '请选择收款账号'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      params['pay_time'] = parseInt(this.costInfo.pay_time.getTime() / 1000)

      this.ledgerDetailEdit(params)
    },
    getAdChnLists () {
      let params = {
        l: 500,
        p: 1,
        opid: this.opid
      }

      if ([2, 4, 16].includes(this.opid)) {
        delete params.opid
      }

      adChnLists(params).then((res) => {
        let data = res.data || {c: -1}

        if (!data.c) {
          this.adChnLists = data.d.lists.map((item, index) => {
            return {
              name: item.name,
              acid: item.acid
            }
          })
        }
      })
    },
    getAdWatchwordLists () {
      let params = {
        l: 500,
        p: 1
      }
      adWatchwordLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.watchwordLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.awid + ')',
              awid: item.awid,
              acid: item.acid,
              all_income: item.all_income,
              chn_amount: item.chn_amount
            }
          })

          this.billWatchLists = this.watchwordLists.slice()
          this.watchwordLists.unshift({
            title: '所有',
            awid: '',
            acid: '',
            all_income: '',
            chn_amount: ''
          })
        }
      })
    },
    getTaskLists () {
      let params = {
        market: 3,
        l: 1000,
        p: 1
      }
      taskLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.taskLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.etid + ')',
              etid: item.etid,
              all_income: item.all_income,
              chn_amount: item.chn_amount
            }
          })
          this.billTaskLists = this.taskLists.slice()
          this.taskLists.unshift({
            title: '所有',
            etid: '',
            all_income: '',
            chn_amount: ''
          })
        }
      })
    },
    getLedgerRecordLists (amount) {
      let params = {
        amount: amount
      }

      ledgerRecordLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.ledgerRecordLists = data.d.lists.map((item, index) => {
            let title = '小小贝'
            if (item.mode === 1) {
              title = '云山支付宝'
            } else if (item.mode === 2) {
              title = '诗雄支付宝'
            }

            title = title + '-' + item.amount
            title = title + '-' + item.username + '(' + item.account + ')'
            title = title + '-' + util.formatTimeStamp(item.trade_time, false)
            title = title + '-' + (item.bind ? '已绑定' : '未绑定')

            return {
              lrid: item.lrid,
              title: title
            }
          })

          this.ledgerRecordLists.unshift({
            lrid: '',
            title: '未登记'
          })
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      }).catch(() => {
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    download () {
      let filters = this.filters
      let link = downloadLedgerLists + '?download=1'

      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.status !== -1) {
        params.status = filters.status
      }
      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.bill_type !== '') {
        params.bill_type = filters.bill_type
      }
      if (filters.title !== '') {
        params.title = filters.title
      }
      if (filters.pay_mode !== '') {
        params.pay_mode = filters.pay_mode
      }
      if (filters.lids !== '') {
        params.lids = filters.lids
      }
      if (filters.amount !== '') {
        params.amount = filters.amount
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      if (filters.awid !== '') {
        params.awid = filters.awid
      }
      if (filters.opid !== '') {
        params.opid = filters.opid
      }
      if (filters.remark !== '') {
        params.remark = filters.remark
      }

      window.open(link, 'a')
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.status !== -1) {
        params.status = filters.status
      }
      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.bill_type !== '') {
        params.bill_type = filters.bill_type
      }
      if (filters.title !== '') {
        params.title = filters.title
      }
      if (filters.pay_mode !== '') {
        params.pay_mode = filters.pay_mode
      }
      if (filters.lids !== '') {
        params.lids = filters.lids
      }
      if (filters.amount !== '') {
        params.amount = filters.amount
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      if (filters.awid !== '') {
        params.awid = filters.awid
      }
      if (filters.etid !== '') {
        params.etid = filters.etid
      }
      if (filters.opid !== '') {
        params.opid = filters.opid
      }
      if (filters.remark !== '') {
        params.remark = filters.remark
      }

      this.listLoading = true
      ledgerLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))
    this.multiReceiveInfo.opid = this.opid
    this.getAdChnLists()
    this.getAdWatchwordLists()
    this.getTaskLists()
    this.getList()
    this.getMonthList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.dateTime': 'dateTimeChange',
    'filters.adid': 'getList',
    'filters.awid': 'getList',
    'filters.etid': 'getList',
    'filters.title': 'getList',
    'filters.bill_type': 'getList',
    'filters.lids': 'getList',
    'filters.amount': 'getList',
    'filters.start_time': 'getList',
    'filters.opid': 'getList',
    'filters.pay_mode': 'getList',
    'filters.remark': 'getList'
  }
}
</script>

<style lang="scss" scoped>
.bill-lists {
  height: 100%;
  width: 800px;
  background-color: #fff;
  padding: 10px;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  // display: flex;
  // flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/page/module/finance/ledgerList.vue